
import { mapActions } from 'vuex'
export default {

  data: () => ({
    deposit: null,
    loading: true
  }),

  computed: {
    depositNumber () {
      return this.$route.params.id
    }
  },

  mounted () {
    this.getDepositDetail(this.depositNumber).then(response => {
      this.deposit = { ...response.data }
      this.loading = false
    }, () => {
      this.$router.push('/dat')
    })
  },

  methods: {
    ...mapActions([
      'getDepositDetail'
    ])
  }

}
